import * as Yup from "yup";

import { ABNValidator, nameValidation } from "lib/validation";
import { PICValidator } from "lib/validation/validators";

import { PIC_DELIMITER } from "constants/sideLoadedBusinesses";

const sideLoadedBusinessValidationSchema = Yup.object().shape({
  name: nameValidation,
  abn: ABNValidator,
  email: Yup.string().email("Invalid email"),
});

export function getSideLoadedBusinessValidationIssues(
  record: SideLoadedBusiness,
): string[] {
  const issues: string[] = [];

  try {
    sideLoadedBusinessValidationSchema.validateSync(record, {
      abortEarly: false,
    });
  } catch (error) {
    if (error instanceof Yup.ValidationError) {
      issues.push(...error.errors);
    } else {
      throw error;
    }
  }

  (record.pics || "")
    .split(PIC_DELIMITER)
    .filter(Boolean)
    .forEach(pic => {
      if (!PICValidator.isValidSync(pic)) {
        issues.push(`Invalid PIC: ${pic}`);
      }
    });

  return issues;
}
